import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { i18n } from './i18n'
import AuthUser from './auth'
import 'vue-loading-overlay/dist/vue-loading.css'
import API from './api'
import VueMeta from 'vue-meta'


const date = new Date();
Vue.config.productionTip = false
i18n.locale = AuthUser.getLocale();

Vue.prototype.$cdnURL = "https://cdn.malloc.house";
Vue.prototype.$baseURL = "https://bchome.ai";
Vue.prototype.$currentYear = date.getFullYear();
Vue.prototype.$supportEmail = "support@bchome.ai";
Vue.use(VueMeta)

router.beforeEach(async (to, from, next) => {
  const pageTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  if (pageTitle) {
    document.title = i18n.t(pageTitle.meta.title)
  }

  if (to.matched.some(record => record.meta.requiresLogin)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters['users/isLoggedIn']) {
      next({ name: 'login', params: { redirect: to.path } })
    } else {
      next() // go to wherever I'm going
    }
  } else if (to.matched.some(record => record.meta.guestOnly)) {
    if (store.getters['users/isLoggedIn']) {
      next({ name: 'dashboard' })
    } else {
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})

router.afterEach(async (to) => {
  store.commit("stepCounterIncr");
  if (to.query._meuvc) {
    await API.verifyEmailUser(to.query._meuvc);
  }
})

/* eslint-disable no-new */
new Vue({
  render: h => h(App),
  router,
  store,
  i18n,
  components: { App },
}).$mount('#app');
